import { EnvVariable } from '../../enums';
import { IOrganizationDevice, IOrganizationUser } from '../../interfaces';
import { getStringEnvVariable } from '../../utils';

const relativeUrl = (path: string, basePath = '/healthcare/api/v1'): URL => {
  return new URL(basePath.concat(path), getStringEnvVariable(EnvVariable.SERVER_HOST));
};

export const HealthcareApiUrls = {
  fetchOrganization(): URL {
    return relativeUrl('/organization');
  },

  fetchOrganizationDevices(): URL {
    return relativeUrl('/organization/devices');
  },

  removeOrganizationDevice(device: IOrganizationDevice): URL {
    const url = relativeUrl(`/organization/devices/${device.serialNumber}`);
    url.search = new URLSearchParams({ unpair: `${device.canUnpair}` }).toString();
    return url;
  },

  orderOrganizationDevices(): URL {
    return relativeUrl('/organization/order-devices');
  },

  fetchOrganizationUsers(): URL {
    return relativeUrl('/organization/account');
  },

  changeOrganizationUserRole(user: IOrganizationUser): URL {
    return relativeUrl(`/organization/account/${user.id}/role`);
  },

  deleteOrganizationUser(user: IOrganizationUser): URL {
    return relativeUrl(`/organization/account/${user.id}`);
  },

  fetchPatients(): URL {
    return relativeUrl('/patient');
  },

  fetchPhysiologicalData(params: {
    startDate: string;
    endDate: string;
    intervalSeconds: string;
    patientId: string;
  }): URL {
    const url = relativeUrl('/physiological/measurement');
    url.search = new URLSearchParams(params).toString();
    return url;
  },

  fetchCuffMeasurements(params: { startDate: string; endDate: string; patientId: string }): URL {
    const url = relativeUrl('/physiological/cuff');
    url.search = new URLSearchParams(params).toString();
    return url;
  },
};
